import { Injectable } from '@angular/core';
import { AppEnum } from '../appenum';
import { AppService } from './app.service';
import { EncryptionService } from './encryption.service';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  public ifconnected: any;
  level = this._appenum.EntityOfLogLevel.All;
  logWithDate: boolean = true;
  ifConnected: any;

  constructor(
    public _appservice: AppService,
    public _appenum: AppEnum,
    public encryptionService: EncryptionService
  ) { }

  private shouldLog(level: any): boolean {
    let ret: boolean = false;
    if (
      (level >= this.level && level !== this._appenum.EntityOfLogLevel.Off) ||
      this.level === this._appenum.EntityOfLogLevel.All
    ) {
      ret = true;
    }
    return ret;
  }

  // New Logging system activity
  async handleError(
    logRequest: any,
    error: any,
    logMessage: any,
    componentName: any
  ) {
    logRequest.error = { result: error };
    await this.apilogs(
      this._appenum.EntityOfLogLevel.Error,
      logMessage,
      componentName,
      logRequest
    );
  }

  async handleResponseLog(
    logRequest: any,
    StatusCode: any,
    Message: any,
    logMessage: any,
    componentName: any
  ) {
    logRequest.response = { responseCode: StatusCode, responseMsg: Message };
    await this.apilogs(
      this._appenum.EntityOfLogLevel.Info,
      logMessage,
      componentName,
      logRequest
    );
  }

  async apilogs(severity, logTextMsg, componentOrPage, logRequestResponse, flag = null) {
    if (this.shouldLog(severity)) {
      const agentId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentid)) || null;
      const sessionId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) || null;
      const deviceId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) || null;
      const deviceInfo = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) || null;
      const postJson = {
        severity: this._appenum.EntityOfLogLevel[severity], //"info/error/warning/critical/",
        logTextMsg: logTextMsg,
        logtime: new Date().toISOString(),
        userId: agentId,
        sessionId: sessionId,
        deviceId: deviceId,
        deviceInfo: deviceInfo,
        componentOrPage: componentOrPage,
        operationMode: 'Assisted Pwa Logs',
        logRequestResponseError: logRequestResponse,
      };
      var postArray = [];
      postArray.push(postJson);
      var res = {
        data: postArray,
      };
      try {
        await this._appservice.postDataWithPromiseWithoutAuth('v2/directLogging', res).then((res) => {

        });
      } catch (error) {
        console.error('Error posting log data:', error);
      }
    }
  }

}
